// @flow

import React, { Component } from 'react'
import moment from 'moment'
import { containerIds } from 'redux/modules/ui'
import { type Room as RoomType } from 'types/room'

export type InquirymodalUseCaseType = {
  initialize: Function,
  openCalendar: Function,
  applyDatePick: Function,
  cancelDatePick: Function,
  changeCalendarFocusedInput: Function,
  changeCalendarDate: Function,
  changePrice: Function,
  changeEventType: Function,
  changeUseType: Function,
  changeCapacity: Function,
  changeDescription: Function,
  changePreviewCheck: Function,
  sendInquiry: Function,
  closeInquiryModal: Function,
}

export default (WrappedComponent: any) =>
  class InquiryModalUseCase extends Component<*> {
    /**
     * 初期処理
     */
    initialize = () => {
      const { actions } = this.props
      actions.setUIState(containerIds.ROOM, {
        isShowCalendar: false,
        planDateText: '',
        startDate: null,
        endDate: null,
        minPrice: null,
        maxPrice: null,
        calendarFocusedInput: 'startDate',
        inquiry: {},
      })
    }

    /**
     * 日付選択カレンダー表示
     */
    openCalendar = (e: Event) => {
      e.preventDefault()
      this.updateUI({
        isShowCalendar: true,
      })
    }

    /**
     * 日付選択カレンダーの選択適用
     */
    applyDatePick = (e: Event, startDate: moment, endDate: moment) => {
      e.preventDefault()
      const { ui } = this.props
      const inquiry = Object.assign(
        {},
        {
          ...ui.inquiry,
          startDate,
          endDate,
        },
      )
      this.updateUI({
        inquiry,
      })
      this.closeDatePick()
    }

    /**
     * 日付選択カレンダーの選択キャンセル
     */
    cancelDatePick = (e: Event) => {
      e.preventDefault()
      const { ui } = this.props
      const inquiry = Object.assign(
        {},
        {
          ...ui.inquiry,
          startDate: null,
          endDate: null,
        },
      )
      this.updateUI({
        inquiry,
      })
      this.closeDatePick()
    }

    /**
     * 日付選択カレンダーを閉じる
     */
    closeDatePick = () => {
      this.updateUI({
        startDate: null,
        endDate: null,
        isShowCalendar: false,
      })
    }

    /**
     * 日付選択カレンダーのFocusChange
     */
    changeCalendarFocusedInput = (focus: string) => {
      this.updateUI({
        calendarFocusedInput: focus,
      })
    }

    /**
     * 日付選択カレンダーの日付選択
     */
    changeCalendarDate = (startDate: moment, endDate: moment) => {
      this.updateUI({
        startDate,
        endDate,
      })
    }

    /**
     * 価格選択スライダーの価格選択
     */
    changePrice = (values: Array<number>) => {
      const minPrice = values[0] >= 1000 ? values[0] : null
      const maxPrice = values[1] <= 100000 ? values[1] : null
      const { ui } = this.props
      const inquiry = Object.assign(
        {},
        {
          ...ui.inquiry,
          maxPrice,
          minPrice,
        },
      )
      this.updateUI({
        minPrice,
        maxPrice,
        isBudgetUnspecified: !minPrice && !maxPrice,
        inquiry,
      })
    }

    /**
     * 目的変更
     */
    changeEventType = (e: SyntheticInputEvent<*>) => {
      e.preventDefault()
      this.updateUI({
        eventType: e.target.value,
      })
    }

    /**
     * 区分変更
     */
    changeUseType = (e: SyntheticInputEvent<*>) => {
      e.preventDefault()
      this.updateUI({
        useType: e.target.value,
      })
    }

    /**
     * 人数変更
     */
    changeCapacity = (e: SyntheticInputEvent<*>) => {
      e.preventDefault()
      this.updateUI({
        capacity: e.target.value,
      })
    }

    /**
     * 問い合わせ事項変更
     */
    changeDescription = (e: SyntheticInputEvent<*>) => {
      e.preventDefault()
      this.updateUI({
        description: e.target.value,
      })
    }

    /**
     * 内覧チェック変更
     */
    changePreviewCheck = (e: SyntheticInputEvent<*>) => {
      const { ui } = this.props
      this.updateUI({
        preview: !ui.preview,
      })
    }

    /**
     * お問い合わせ送信
     */
    sendInquiry = (e: Event) => {
      e.preventDefault()
      const { room, actions, ui } = this.props
      actions.sendInquiry({
        room,
        params: {
          ...ui,
          ...ui.inquiry,
        },
      })
    }

    /**
     * お問い合わせモーダルを非表示
     */
    closeInquiryModal = (e: Event) => {
      e.preventDefault()
      this.updateUI({ isOpenInquiry: false })
    }

    updateUI = (updated: Object) => {
      const { actions } = this.props
      actions.setUIState(containerIds.ROOM, {
        ...updated,
      })
    }

    render() {
      return <WrappedComponent {...this.props} usecase={this} />
    }
  }



// WEBPACK FOOTER //
// ./src/containers/organisms/room/InquiryModal/usecase.jsx